<script setup lang="ts">
import SectionCustomerComments from './comments/SectionCustomerComments.vue'

defineOptions({
  name: 'CustomerCommentsPage',
})
</script>

<template>
  <SectionCustomerComments />
</template>
